const PAYMENT_GATEWAYS = {
    STRIPE: 0,
    PAYPAL: 1,
    WALLET: 2,
};
const STRIPE_PAYMENT_METHOD_PAYMENT_TYPES = {
    CARD: 'card',
    ACH: 'ach',
};
const STRIPE_ONBOARDING_STATUSES = {
    NOT_ONBOARDED: 0,
    COMPLETE: 1,
    NEW_REQUIREMENTS: 2,
};
const VERIFIED_PAYMENT_METHOD_STATUSES = {
    PENDING: 0,
    TRY_AGAIN: 20,
    FAILED: 30,
    VERIFIED: 50,
};
const WALLET_ACCOUNT_TYPES = {
    CASH: 'CASH',
    EARN: 'EARN',
    EXTERNAL: 'EXTERNAL',
    TAX_RESERVES: 'TAX_RESERVES',
    TPA_PENDING: 'TPA_PENDING',
};
const WALLET_ONBOARDING_STATUSES = {
    PENDING_VERIFICATION: 0,
    ACTIVE: 1,
    SUSPENDED: 2,
    MANUAL_REVIEW: 3,
    UNVERIFIED: 4,
};
export { PAYMENT_GATEWAYS, STRIPE_PAYMENT_METHOD_PAYMENT_TYPES, STRIPE_ONBOARDING_STATUSES, VERIFIED_PAYMENT_METHOD_STATUSES, WALLET_ACCOUNT_TYPES, WALLET_ONBOARDING_STATUSES, };
